import React from 'react';
import PropTypes from 'prop-types';

import { gettext } from '../utils/text';
import CSRFToken from './CSRFToken';
import { VISIBILITY_PUBLIC, VISIBILITY_PUBLIC_DISPLAY } from '../utils/constants';
import UploadBox from './UploadBox';
import DeleteButton from './DeleteButton';

/**
 * Component for comment form
 *
 */
class CommentForm extends React.Component {
    static propTypes = {
        modelName: PropTypes.string,
        pk: PropTypes.number,
        acceptAttachments: PropTypes.bool,
        visibilityChoices: PropTypes.object,
    };

    static defaultProps = {
        modelName: null,
        pk: null,
        acceptAttachments: false,
        visibilityChoices: {
            VISIBILITY_PUBLIC: VISIBILITY_PUBLIC_DISPLAY,
        },
    };

    constructor(props) {
        super(props);
        this.state = {
            fileId: Math.random(),
        };
    }

    componentDidMount() {}

    componentWillUnmount() {
        // Revoke preview to avoid memory leaks
        if (this.state.file) {
            window.URL.revokeObjectURL(this.state.file);
        }
    }

    onDrop(acceptedFiles, rejectedFiles) {
        if (acceptedFiles.length > 0) {
            const acceptedFile = acceptedFiles[0];
            this.setState({
                file: acceptedFile,
            });
        }
        if (acceptedFiles.length > 1) {
            this.setState({
                errorMessage: gettext('You can only upload one attachment at a time.'),
            });
        }
        if (rejectedFiles.length > 0) {
            this.setState({
                errorMessage: gettext('Some of the file(s) you uploaded were rejected because of their type'),
            });
        }
    }

    formActionUrl() {
        return `/commentp/add/${this.props.modelName}/${this.props.pk}/`;
    }

    deleteMedia() {
        if (this.state.file) {
            window.URL.revokeObjectURL(this.state.file);
            this.setState({
                file: null,
                fileId: Math.random(),
            });
        }
    }

    attachmentField = () => {
        const displayPreview = !!this.state.file;

        return (
            <div className="d-flex flex-column">
                {this.state.file && (
                    <a
                        href={this.state.file && this.state.file.preview}
                        style={{
                            display: !displayPreview && 'none',
                        }}
                        target={'_blank'}
                    >
                        {this.state.file.name}
                    </a>
                )}
                <div
                    style={{
                        display: displayPreview && 'none',
                    }}
                >
                    <UploadBox
                        height="7rem"
                        key={this.state.fileId}
                        onDrop={(...args) => this.onDrop(...args)}
                        multiple={false}
                        name="attachment"
                    />
                </div>
                <div
                    style={{
                        display: !displayPreview && 'none',
                    }}
                    className="ml-auto mr-auto mt-2"
                >
                    <DeleteButton onClick={() => this.deleteMedia()} />
                </div>
            </div>
        );
    };

    visibilityFields = () => {
        const defaultVis = VISIBILITY_PUBLIC;
        return Object.entries(this.props.visibilityChoices).map(([value, name], index) => {
            return (
                <div className="radio-button--wrapper form-group" key={value}>
                    <input
                        type="radio"
                        className="form-check-input"
                        defaultChecked={value === defaultVis.toString(10)}
                        name="visibility"
                        id={`id_visibility_${index}`}
                        value={value}
                    />
                    <label className="radio-button small" htmlFor={`id_visibility_${index}`} />
                    <label htmlFor={`id_visibility_${index}`} className="form-radio-label form-check-inline">
                        {name}
                    </label>
                </div>
            );
        });
    };

    render() {
        const showVisibility = Object.entries(this.props.visibilityChoices).length > 1;
        return (
            <form action={this.formActionUrl()} method="post" encType="multipart/form-data">
                <CSRFToken />
                <div id="div_id_message" className="form-group">
                    <label htmlFor="id_message" className="requiredField">
                        {gettext('Add comment')}
                        <span className="asteriskField">*</span>
                    </label>
                    <div className="">
                        <textarea
                            name="message"
                            rows="10"
                            id="id_message"
                            minLength="1"
                            required
                            cols="40"
                            className="textarea form-control"
                        />
                    </div>
                </div>
                {this.props.acceptAttachments && this.attachmentField()}

                <div className="comment-addform-tools">
                    <div id="div_id_visibility" className={`form-group ${showVisibility ? '' : 'd-none'}`}>
                        <label htmlFor="id_visibility" className=" requiredField">
                            Visibility<span className="asteriskField">*</span>
                        </label>
                        <div className="form-check">{this.visibilityFields()}</div>
                    </div>

                    <div className="buttonHolder">
                        <input
                            type="submit"
                            name="submit"
                            value={gettext('Send comment')}
                            className="text-btn link"
                            id="submit-id-submit"
                        />
                        <span className="button-arrow" />
                    </div>
                </div>
            </form>
        );
    }
}

export default CommentForm;



// WEBPACK FOOTER //
// ./src/components/CommentForm.js